module.exports = __webpack_public_path__ + "img/wz-3-3.7d8af69f.jpg";